import React, { useState, useRef, useEffect } from 'react';
import { DatePicker, Spin } from 'antd';
import { Checkbox as CrceCheckbox } from '@crc-evans/ui-components';
import moment from 'moment';

const DSRSectionBreadcrumb = ({
  selectedDate,
  onDateChange,
  shift,
  sectionTitle,
  skipped,
  onSkipChange,
  isSubmitted = false,
  disabled = false,
  isUpdatingDsrLogSections = false,
  isShiftSkipped = false,
}) => {
  const [localSkipped, setLocalSkipped] = useState(skipped);
  const hasUserInteracted = useRef(false);
  const lastParentValue = useRef(skipped);
  const currentSectionKey = useRef(`${sectionTitle}-${shift}`);

  useEffect(() => {
    if (lastParentValue.current !== skipped) {
      lastParentValue.current = skipped;
      if (!hasUserInteracted.current) {
        setLocalSkipped(skipped);
      }
    }
  }, [skipped, sectionTitle]);

  useEffect(() => {
    const newSectionKey = `${sectionTitle}-${shift}`;
    if (currentSectionKey.current !== newSectionKey) {
      currentSectionKey.current = newSectionKey;
      hasUserInteracted.current = false;
      setLocalSkipped(skipped);
      lastParentValue.current = skipped;
    }
  }, [sectionTitle, shift, skipped]);

  const handleSkipChange = (checkedOrEvent) => {
    const newValue = typeof checkedOrEvent === 'boolean'
      ? checkedOrEvent
      : (checkedOrEvent?.target?.checked ?? false);
    setLocalSkipped(newValue);
    hasUserInteracted.current = true;
    onSkipChange({ target: { checked: newValue } });
  };

  return (
    <div
      className="modern-dsr-section-bc-row"
      style={{
        padding: '2px 0 2px 0',
        display: 'inline-flex',
        alignItems: 'center',
        gap: 16,
        minHeight: 32,
        minWidth: 0,
        flex: '0 1 auto',
      }}
    >
      <div className="modern-dsr-form-date-wrap" style={{ width: 150 }}>
        <DatePicker
          className="modern-dsr-form-date-picker"
          size="middle"
          format="DD-MMM-YYYY"
          placeholder="Select DSR date"
          value={selectedDate ? moment(selectedDate) : null}
          onChange={(date) => {
            if (onDateChange && date) {
              onDateChange(moment(date).startOf('day'));
            }
          }}
          disabledDate={(current) => current && current > moment().endOf('day')}
          allowClear={false}
          disabled={isSubmitted}
          dropdownClassName="modern-dsr-date-dropdown"
        />
      </div>

      <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
        {isUpdatingDsrLogSections && (
          <Spin
            size="small"
            style={{ marginRight: 4 }}
          />
        )}

        {isShiftSkipped ? (
          <div
            style={{
              color: '#faad14',
              fontSize: '14px',
              fontWeight: '500',
              backgroundColor: 'rgba(250, 173, 20, 0.1)',
              padding: '4px 10px',
              borderRadius: '25px',
              border: '1px solid #faad14',
              height: '24px',
              display: 'flex',
              alignItems: 'center',
            }}
          >
            {shift.charAt(0).toUpperCase() + shift.slice(1)} Shift Skipped
          </div>
        ) : (
          <CrceCheckbox
            label={`Skip ${sectionTitle}`}
            checked={localSkipped}
            onChange={handleSkipChange}
            disabled={disabled || isUpdatingDsrLogSections}
            borderColor="#00a88e"
          />
        )}
      </div>
    </div>
  );
};

export default DSRSectionBreadcrumb;
